import { FC } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

const Line = styled.div`
  flex: 1 0 0;
  height: 1px;
  background: ${({ theme }) => theme.color.lightGrey};
`

const Text = styled.span`
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize12};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

export const OrDivider: FC<{ className?: string }> = ({ className }) => (
  <Wrapper className={className}>
    <Line />
    <Text>or</Text>
    <Line />
  </Wrapper>
)
